// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".donations[data-v-2481393f]{width:100%;padding-bottom:60px}.donations h1[data-v-2481393f]{margin-bottom:30px;margin-top:0}.donations__section[data-v-2481393f]{width:100%;max-width:350px;margin-bottom:30px}.donations__section[data-v-2481393f]:last-child{margin-bottom:0}.donations__section[data-v-2481393f]  .wrap-of-chars>.list{width:100%;margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
